




















import { BarChartValues } from "@/types/bar-chart";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class BarChartRow extends Vue {
  @Prop({ required: true })
  values!: BarChartValues;

  get total() {
    return this.values.a.value + this.values.b.value;
  }

  get fill() {
    const percent = this.total > 0 ? (this.values.a.value / this.total) * 100 : 0;
    return { transform: `translateX(${percent}%)` };
  }

  get fillBackground() {
    return this.total > 0 ? "filled" : "";
  }
}
